export const MerchantSelectionViewReferenceCodeUat = {
  referenceCode: 'merchantSelection.referenceCode',
}
